import { Flex } from 'antd';
import styled from 'styled-components';

import { QuestionCircleOutlined } from '@ant-design/icons';

export const StyledTooltipIcon = styled(QuestionCircleOutlined)`
  color: ${({ theme }) => theme.colorIcon};
`;

export const Wrapper = styled(Flex).attrs({
  gap: 4,
})<{ $disabled?: boolean }>`
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;
